import { userTheme } from 'consts/config';
import themeSet from './theme';

export const REFRESH_TIME_STEP = 5;
export const OGN_DATA_PERIOD = 10;
export const ZONES_COLORS = {
  AREA: '42,131,135',
  ATZ6KM: '184,104,208',
  D: '252,43,70',
  TSA: '252,43,70',
  R: '252,43,70',
  MRT: '34,92,19',
  NW: '252,43,70',
  RPA: '128, 0, 0',
  MTMA: '64,125,217',
  TFR: '56,65,219',
  TRA: '211,126,186',
  TMA: '64,125,217',
  ATZ1KM: '252,43,70',
  CTR1KM: '252,43,70',
  RMZ: '209,184,246',
  MCTR2KM: '252,43,70',
  ATZ: '117,106,90',
  CTR6KM: '184,104,208',
  P: '252,43,70',
  CTR: '56,65,219',
  MCTR: '34,92,19',
  ADIZ: '173,173,150',
  SELECTED: '255, 64, 0',
  FIS: '118,135,228',
  DEFAULT: '161,165,163',
  TMPR: '255, 0, 0',
  TMP: '253, 228, 86',
  'DRA-R': '255,255,0',
  'DRA-I': '0,0,255',
  'DRA-P': '255,0,0',
  'DRA-RH': '255,255,0',
  'DRA-RM': '255,255,0',
  'DRA-RL': '255,255,0',
  'DRA-T': '24,197,219',
  'DRA-U': '58,117,181',
  'DRA-RH_LOCAL': '255,255,0',
  'DRA-I_LOCAL': '0,0,255',
  'DRA-P_LOCAL': '255,0,0',
  'DRA-R_LOCAL': '255,255,0',
  'DRA-RM_LOCAL': '255,255,0',
  'DRA-RL_LOCAL': '255,255,0',
  'DRA-T_LOCAL': '24,197,219',
  'DRA-U_LOCAL': '58,117,181',
};

export const INACTIVE_ZONE = {
  stroke: 'rgba(255, 64, 0, 1)',
  lineWidth: 2,
  lineDash: [2, 5],
};

export const UAVOS_ICONS = {
  ufo: '/icons/ufo.svg',
};

export const UAVO_TYPE_FALLBACK = {
  'jet aircraft': 'plane',
  'powered aircraft': 'plane',
  'unknown': 'ufo',
};

export const MAP_TILES = {
  mbLight: 'mbLight',
  mbDark: 'mbDark',
  mbSatellite: 'mbSatellite',
  mbOutdoors: 'mbOutdoors',
  mbStreets: 'mbStreets',
  osm: 'osm',
};

export const WEATHER_TILES = {
  temperature: 'temperature',
  pressure: 'pressure',
  wind: 'wind',
  clouds: 'clouds',
  precipitation: 'precipitation',
};

export const UAVO_NON_ROTABLE = [
  'ufo',
  'balloon',
  'parachute',
  'para-glider',
  'hang-glider',
  'ground support',
  'airship',
  'unknown',
];

const UAVO_ICON_COLOR = {};
UAVO_ICON_COLOR.default = 'rgba(0, 0, 0, 1)';
UAVO_ICON_COLOR[MAP_TILES.mbDark] = 'rgba(255, 255, 177, 1)';
UAVO_ICON_COLOR[MAP_TILES.mbSatellite] = 'rgba(255, 255, 177, 1)';
export { UAVO_ICON_COLOR };

// export const UAVO_ICON_COLOR = {mbLight :'rgba(0, 0, 0, 1)'};
export const UAVO_ICON_COLOR_SELECTED = 'rgba(255,165,0, 1)';
export const UAVO_ICON_SCALE = 0.22;
export const UAVO_ICON_SCALE_SELECTED = 0.32;
export const UAVO_HISTORY_PERIOD = 1; // in hours
export const UAVO_ICONS_BACK = {
  noColor: 'rgba(14, 165, 233, 0)',
  friend: 'rgb(16, 185, 129)',
  enemy: 'rgb(239, 68, 68)',
  stroke: 'rgba(14, 165, 233, 0)',
  radius: 13,
  strokeWidth: 1.5,
};

export const UAVO_ICONS_TEXT = {
  scale: 1.3,
  offsetY: -20,
  offsetX: 20,
  color: 'rgba(0,0,0,1)',
  padding: [2, 2, 2, 2],
};

export const OPERATION_ICONS_BACK = {
  stroke: {
    accepted: 'rgba(16, 185, 129, 1)',
    rejected: 'rgba(239, 68, 68, 1)',
    verify: 'rgba(59, 130, 246, 1)',
    created: 'rgba(59, 130, 246, 1)',
  },
  zoomedFill: {
    accepted: 'rgba(16, 185, 129, 0.3)',
    rejected: 'rgba(239, 68, 68, 0.3)',
    verify: 'rgba(59, 130, 246, 0.3)',
    created: 'rgba(59, 130, 246, 0.3)',
  },
  radius: 13,
  zoomedRadius: 18,
  strokeWidth: 1.5,
  strokeZoomedWidth: 4,
};

export const OPERATION_ICON = {
  src: '/icons/operation.svg',
  scale: 0.5,
  color: {
    accepted: 'rgba(16, 185, 129, 1)',
    rejected: 'rgba(239, 68, 68, 1)',
    verify: 'rgba(59, 130, 246, 1)',
    created: 'rgba(59, 130, 246, 1)',
  },
};

export const ZOOMING_ANIMATION_UAVO_DURATION = 500;

export const STATUS_COLORS = {
  default: '#0F172A',
  white: '#F8FAFC',
  accepted: {
    fill: 'rgba(16, 185, 129, 0.2)',
    stroke: '#10B981',
    text: 'green',
  },
  acceptedAck: {
    fill: 'rgba(16, 185, 129, 0.3)',
    stroke: '#34D399',
    text: 'lightGreen',
  },
  atcModified: {
    fill: 'rgba(6, 182, 212, 0.2)',
    stroke: '#0891B2',
    text: 'darkTeal',
  },
  atcModifiedAck: {
    fill: 'rgba(6, 182, 212, 0.2)',
    stroke: '#06B6D4',
    text: 'teal',
  },
  rejected: {
    fill: 'rgba(239, 68, 68, 0.2)',
    stroke: '#EF4444',
    text: 'red',
  },
  rejectedAck: {
    fill: 'rgba(239, 68, 68, 0.2)',
    stroke: '#DC2626',
    text: 'red',
  },
  blocked: {
    fill: 'rgba(239, 68, 68, 0.2)',
    stroke: '#EF4444',
    text: 'red',
  },
  planned: {
    fill: 'rgba(245, 158, 11, 0.2)',
    stroke: '#F59E0B',
    text: 'orange',
  },
  created: {
    fill: 'rgba(59, 130, 246, 0.2)',
    stroke: '#3B82F6',
    text: 'blue',
  },
  inQueue: {
    fill: 'rgba(161, 98, 7, 0.2)',
    stroke: '#A16207',
    text: 'brown',
  },
  landNow: {
    fill: 'rgba(168, 85, 247, 0.2)',
    stroke: '#A855F7',
    text: 'darkPurple',
  },
  landingAck: {
    fill: 'rgba(30, 58, 138, 0.2)',
    stroke: '#1E3A8A',
    text: 'darkBlue',
  },
  lostControl: {
    fill: 'rgba(239, 68, 68, 0.3)',
    stroke: '#EF4444',
    text: 'red',
  },
  seen: {
    stroke: '#7C3AED',
    text: 'purple',
  },
  selected: {
    fill: 'rgba(6, 182, 212, 0.2)',
    stroke: 'rgba(6, 182, 212, 0.6)',
    width: 8,
  },
  textColor: '#F8FAFC',
  verify: {
    fill: 'rgba(59, 130, 246, 0.2)',
    stroke: '#3B82F6',
    text: 'blue',
  },
  groupOfGeometries: 'rgba(245, 158, 11, 0.8)',
  pickedOneGeomtryOutOfTheGroup: 'rgba(249, 115, 22, 0.8)',
};

export const RULER_STYLE = themeType => ({
  stroke: {
    color: themeSet[userTheme[themeType] || 'light'].palette.primary.main,
    width: 2,
  },
});

export const MULTI_POINT_STYLE = themeType => ({
  stroke: {
    color: themeSet[userTheme[themeType] || 'light'].palette.primary.main,
    width: 2,
  },
});

export const LABEL_POINT_STYLE = themeType => ({
  fill: {
    color: themeSet[userTheme[themeType] || 'light'].palette.primary.main,
  },
  stroke: {
    color: themeSet[userTheme[themeType] || 'light'].palette.primary.main,
    width: 0.8,
  },
});

export const APPROVED_AREAS_STYLE = {
  stroke: {
    color: 'rgba(0, 80, 0, 0.7)',
    width: 2,
  },
  fill: { color: 'rgba(0, 80, 0, 0.1)' },
  selected: {
    stroke: {
      color: 'rgba(255,165,30, 1)',
      width: 2,
    },
    fill: { color: 'rgba(255,165,30, 0.1)' },
  },
};

export const TRACK_LINE_STYLE = {
  stroke: {
    color: 'rgba(6, 182, 212, 0.8)',
    width: 2,
  },
};

export const RECEIVER_LINE_STYLE = {
  stroke: {
    color: 'rgba(0, 0, 255)',
    width: 3,
  },
};

export const FEATURES_DETAIL = {
  uavo: {
    ogn: 'OGN',
    utm: 'UTM',
  },
  zones: 'zone',
};

export const UAVOS_SOURCES_TYPES = {
  drones: 'drone',
  aircrafts: 'aircraft',
};

export const UAVOS_SOURCES = {
  utm: 'UTM',
  simulator: 'SIM-V1-R-RO-987-SP',
  aircrafts: 'aircraft',
};

export const DEFAULT_MAP_WIDTH = 7;
